// extracted by mini-css-extract-plugin
export default {"innerWrapper":"my-z","tooltipWrapper":"ny-z","icon":"oy-z","tooltip":"py-z","content":"qy-z"};